import { DataSource } from '@client/core/data/concerns/data-source';
import { fromJson, JsonResponse } from '@client/core/data/concerns/parses-from-json';
import { Pagination } from '@client/core/http/pagination';
import { CountResponse, HttpResponse, HttpResponseWithMeta, PaginationResponse } from '@client/core/http/types';
import { DatabaseNotification } from '@client/features/notifications/models/database-notification';
import { GetUserNotificationsParams } from '@client/features/notifications/use-cases/get-user-notifications';

export class NotificationDataSource extends DataSource {
  async getUserNotifications(params: GetUserNotificationsParams): Promise<PaginationResponse<DatabaseNotification[]>> {
    const uri = `/notifications`;
    const response = await this.httpClient.get<HttpResponseWithMeta<JsonResponse[], Pagination>>(uri, {
      params: {
        ...params,
        page: params?.page ?? 1,
      },
    });

    return {
      pagination: fromJson(Pagination, response.data.meta),
      data: response.data.data.map((notification) => fromJson(DatabaseNotification, notification)),
    };
  }

  async getUserUnreadNotificationsCount(): Promise<CountResponse> {
    const uri = `/notifications/count`;
    const response = await this.httpClient.get<HttpResponse<JsonResponse>>(uri);

    return {
      count: response.data.data.count as number,
    };
  }

  async markNotificationsAsRead(): Promise<void> {
    const uri = `/notifications/mark-as-read`;
    await this.httpClient.patch<HttpResponse<JsonResponse>>(uri);
  }
}
